
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ophav/[creatorId]",
      function () {
        return require("private-next-pages/ophav/[creatorId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ophav/[creatorId]"])
      });
    }
  